import { apiClient } from '@/lib/apiClient';

import type { Baermann, BaermannCreate, BaermannUpdate } from './types';

const base = (uidProtocolo: string) => `/protocolos/${uidProtocolo}/analisis-baermann`;

export const baermannApi = {
  async create(
    uidProtocolo: string,
    data: BaermannCreate,
    signal?: AbortSignal
  ): Promise<Baermann> {
    const response = await apiClient.post<Baermann>(base(uidProtocolo), data, { signal });
    return response.data;
  },

  async listByProtocolo(uidProtocolo: string, signal?: AbortSignal): Promise<Baermann[]> {
    const response = await apiClient.get<Baermann[]>(base(uidProtocolo), { signal });
    return response.data;
  },

  async getById(
    uidProtocolo: string,
    uidAnalisis: string,
    signal?: AbortSignal
  ): Promise<Baermann> {
    const response = await apiClient.get<Baermann>(
      `${base(uidProtocolo)}/${uidAnalisis}`,
      { signal }
    );
    return response.data;
  },

  async update(
    uidProtocolo: string,
    uidAnalisis: string,
    data: BaermannUpdate,
    signal?: AbortSignal
  ): Promise<Baermann> {
    const response = await apiClient.patch<Baermann>(
      `${base(uidProtocolo)}/${uidAnalisis}`,
      data,
      { signal }
    );
    return response.data;
  },

  async remove(uidProtocolo: string, uidAnalisis: string, signal?: AbortSignal): Promise<void> {
    await apiClient.delete(`${base(uidProtocolo)}/${uidAnalisis}`, { signal });
  },
};
